import { useIntl } from 'react-intl'

import { AttachmentProps } from '@/app/models/attachment'

import { LuxMultiSelect, LuxTextInput, LuxRichInputText } from '@lux/wardrobe-lib'
import {
    FolderType,
    FormProps,
    ResourceProps,
    ResourceType,
    Visibility,
} from '@/app/models/new-resource'
import './Information.scss'
import { ResourcesService } from '@/app/services/ResourcesService'

const Information = (props: {
    isEdit: boolean
    linkTitle: string
    setLinkTitle: (t: string) => void
    linkURL: string
    setLinkURL: (l: string) => void
    visibility: Visibility[]
    setVisibility: (v: Visibility[]) => void
    visibilityList: any[]
    linkDescription: string
    setLinkDescription: (d: string) => void
}) => {
    const {
        isEdit,
        linkTitle,
        setLinkTitle,
        linkURL,
        setLinkURL,
        visibility,
        setVisibility,
        visibilityList,
        linkDescription,
        setLinkDescription,
    } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-quick-link-information'

    intl.formatMessage({
        id: 'modals.edit_quick_links.title',
        defaultMessage: 'Edit Quick Link',
    })

    return (
        <div className={`${componentClass}`}>
            <div className={`${componentClass}__first-row-info`}>
                <div className="linkTitle">
                    <LuxTextInput
                        icon="pencil"
                        mandatory={true}
                        value={linkTitle}
                        label={intl.formatMessage({
                            id: 'modals.link_title_label',
                            defaultMessage: 'Link title',
                        })}
                        iconPosition="right"
                        placeholder={intl.formatMessage({
                            id: 'modals.quicklinks.placeholder',
                            defaultMessage: 'Type here...',
                        })}
                        onChangeCallback={(e: any) => setLinkTitle(e)}
                    />
                </div>
                <div className={'linkURL'}>
                    <LuxTextInput
                        icon="pencil"
                        mandatory={true}
                        value={linkURL}
                        label={intl.formatMessage({
                            id: 'modals.link_url_label',
                            defaultMessage: 'URL',
                        })}
                        iconPosition="right"
                        placeholder={intl.formatMessage({
                            id: 'modals.quicklinks.placeholder',
                            defaultMessage: 'Type here...',
                        })}
                        onChangeCallback={(e: any) => setLinkURL(e)}
                    />
                </div>
            </div>
            <div className={`${componentClass}__visibility ${isEdit ? 'disabled' : ''}`}>
                <LuxMultiSelect
                    mandatory={true}
                    value={visibility}
                    onChangeCallback={(v: any) => setVisibility(v)}
                    label={intl.formatMessage({
                        id: 'modals.link_visibility_by_role_label',
                        defaultMessage: 'Visibility by Role',
                    })}
                    placeholder={intl.formatMessage({
                        id: 'modals.new_resource.visibility.placeholder',
                        defaultMessage: 'Select role',
                    })}
                    options={visibilityList.map((visibility: { value: string; label: string }) => ({
                        ...visibility,
                        label: intl.formatMessage({
                            id: visibility.label,
                            defaultMessage: visibility.label.split('.').pop(),
                        }),
                    }))}
                    additionalProps={{
                        appendTo: 'self',
                    }}
                />
            </div>
            <div className={`${componentClass}__description`}>
                <LuxRichInputText
                    mandatory={false}
                    label={intl.formatMessage({
                        id: 'modals.link_description_label',
                        defaultMessage: 'Description',
                    })}
                    value={linkDescription}
                    onChangeCallback={(value: any) => {
                        setLinkDescription(value)
                    }}
                    fileUploadUrl={ResourcesService.FROALA_UPLOAD_URL}
                    placeholder={intl.formatMessage({
                        id: 'modals.quicklinks_description.placeholder',
                        defaultMessage: 'Type here',
                    })}
                />
            </div>
        </div>
    )
}

export default Information
